import { useNavigate } from 'react-router-dom';
import { Card } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import SystemSettingForm from '../components/SystemSettingForm';
import { useCreateSystemSetting } from '../hooks/useSystemSettingMutations';

export default function SystemSettingCreatePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const mutation = useCreateSystemSetting();
  const handleSubmit = (data: any) => { mutation.mutate(data, { onSuccess: () => navigate('/system-settings') }); };
  return (
    <div>
      <PageHeader back title={t('systemSettings.addTitle')} subtitle={t('systemSettings.addSubtitle')} />
      <Card><SystemSettingForm onSubmit={handleSubmit} isLoading={mutation.isPending} /></Card>
    </div>
  );
}
